import { render, staticRenderFns } from "./matriculas.vue?vue&type=template&id=e7413e4c&scoped=true&"
import script from "./matriculas.vue?vue&type=script&lang=js&"
export * from "./matriculas.vue?vue&type=script&lang=js&"
import style0 from "./matriculas.vue?vue&type=style&index=0&id=e7413e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7413e4c",
  null
  
)

export default component.exports